import {
    Dialog,
    DialogContent,
    DialogOverlay,
    DialogPortal,
    DialogTitle,
    DialogTrigger,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Combobox } from '../utils/combobox';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { MdLocationOn } from 'react-icons/md';
import { setShowCityModal } from '@/lib/RTK/features/AdmissionSlice';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import { useMutation } from '@tanstack/react-query';
import { baseURLApi } from '@/lib/servies/axiosConfig';
import { toast } from '../ui/use-toast';
import { changeCity } from '@/utils/actions/change-city';
import { useRouter } from 'next/navigation';

const CityModal = ({
    data,
}: {
    data: {
        centers: {
            id: number;
            name: string;
            slug: string;
            province_name: string;
        }[];
        cities: {
            id: number;
            name: string;
            province: { name: string };
            province_id: number;
            slug: string;
        }[];
    };
    trigger?: boolean;
}) => {
    const router = useRouter();
    const cities = data?.cities.map((city) => {
        return {
            label: city.name,
            value: String(city.id),
        };
    });
    const [city, setCity] = useState('');
    const showCityModal = useAppSelector(
        (state) => state.admission.showCityModal,
    );
    const [selectedIdCity, setSelectedIdCity] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [open, setOpen] = useState(false);
    const { token } = useAppSelector((s) => s.auth_token_slice);

    useEffect(() => {
        const city = Cookies.get('cityInfo') || '';
        const cityId = Cookies.get('cityId') || '';
        setSelectedIdCity(cityId);
        setCity(city);
    }, []);

    const cityInfo = Cookies.get('cityInfo') || '';
    const cityId = Cookies.get('cityId') || '';

    useEffect(() => {
        setSelectedIdCity(cityId);
        setCity(cityInfo);
    }, [cityId, cityInfo]);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setOpen(showCityModal);
    }, [showCityModal]);

    const submitUserCity = useMutation({
        mutationFn: (data: { city_id: string; type: string }) => {
            return fetch(
                `${baseURLApi}/set_user_city?city_id=${data.city_id}&type=${data.type}`,
                {
                    method: 'POST',
                    headers: {
                        Auth: `Bearer ${token}`,
                    },
                },
            ).then(async (response) => response.json());
        },
        onError: () => {
            toast({
                title: 'فرایند ثبت شهر با شکست مواجه شد',
                variant: 'error',
            });
        },
    });

    const options = data?.centers.map((city) => {
        return {
            label: `${city.name}/ استان ${city.province_name}`,
            value: String(city.id),
        };
    });
    return (
        <Dialog
            open={open}
            onOpenChange={(open) => {
                setOpen(open);
                if (open) {
                    const city = Cookies.get('cityInfo') || '';
                    const cityId = Cookies.get('cityId') || '';
                    setSelectedIdCity(cityId);
                    setCity(city);
                    dispatch(setShowCityModal(false));
                }
            }}
        >
            <DialogTrigger className="px-4 rounded-lg smp:!ml-1 bg-blue-300/50 hover:bg-blue-300/70 !p-0 flex gap-2 items-center justify-between text-blue-700">
                <div className="text-sm flex gap-1 items-center font-medium ml-2">
                    {' '}
                    <MdLocationOn />{' '}
                    <p className="smp:!max-w-full max-w-[55px] xs:!max-w-[77px] sm:!max-w-[95px] truncate">
                        {city ? city : 'انتخاب شهر'}
                    </p>
                </div>
                {/* </Button> */}
            </DialogTrigger>

            <DialogPortal>
                <DialogOverlay className="fixed inset-0 bg-black opacity-20" />
                <DialogContent className="data-[state=open]:animate-contentShow !rounded-2xl fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[540px] translate-x-[-50%] translate-y-[-50%] bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
                    <DialogTitle className="sr-only"></DialogTitle>
                    <div>
                        <p className="font-semibold">شهر های پر بازدید</p>
                        {data?.centers ? (
                            <div className="flex flex-row gap-3 pt-3 flex-wrap">
                                {data.centers.slice(0, 6).map((city) => (
                                    <Button
                                        key={city.id}
                                        variant={
                                            selectedIdCity === String(city.id)
                                                ? 'blue'
                                                : 'blueShaded'
                                        }
                                        onClick={() => {
                                            setSelectedIdCity(String(city.id));
                                            setSelectedCity(
                                                `${city.province_name}-${city.name}`,
                                            );
                                            changeCity(
                                                String(city.id),
                                                `${city.province_name}-${city.name}`,
                                            );
                                            router.refresh();
                                            setCity(
                                                `${city.province_name}-${city.name}`,
                                            );
                                            submitUserCity.mutate({
                                                city_id: String(city.id),
                                                type: showCityModal ? '1' : '2',
                                            });
                                            dispatch(setShowCityModal(false));

                                            setOpen(false);
                                        }}
                                    >
                                        {city.name}
                                    </Button>
                                ))}
                                <Button
                                    variant={
                                        selectedIdCity === String(null)
                                            ? 'blue'
                                            : 'blueShaded'
                                    }
                                    onClick={() => {
                                        Cookies.set('cityInfo', '');
                                        Cookies.set('cityId', '');

                                        router.refresh();
                                        submitUserCity.mutate({
                                            city_id: '0',
                                            type: '2',
                                        });
                                        dispatch(setShowCityModal(false));
                                        setOpen(false);
                                    }}
                                >
                                    همه شهر ها
                                </Button>
                            </div>
                        ) : (
                            ''
                        )}

                        <hr className="w-full my-4 border-gray-200" />
                        <p className="font-semibold pb-3">
                            شهر خود را انتخاب کنید
                        </p>
                        {cities ? (
                            <Combobox
                                placeholder="گزینه ها"
                                options={options}
                                value={selectedIdCity}
                                btnClassName="!bg-white !rounded-2xl h-[45.6px]"
                                onChange={(selectedItem) => {
                                    setSelectedIdCity(
                                        selectedItem
                                            ? String(selectedItem)
                                            : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                              (null as any),
                                    );
                                    const city = data.cities.find(
                                        (city) =>
                                            String(city.id) == selectedItem,
                                    );
                                    if (city) {
                                        setSelectedCity(
                                            `${city.province.name}-${city.name}`,
                                        );
                                    }
                                }}
                                removeHandler={() => {
                                    setSelectedIdCity('');
                                }}
                            />
                        ) : (
                            ''
                        )}

                        <Button
                            disabled={!selectedIdCity}
                            variant={'blue'}
                            className="w-full mt-4"
                            onClick={() => {
                                changeCity(selectedIdCity, selectedCity);
                                router.refresh();
                                // Cookies.set('cityId', selectedIdCity);
                                // Cookies.set('cityInfo', selectedCity);
                                setCity(selectedCity);
                                setOpen(false);
                                submitUserCity.mutate({
                                    city_id: selectedIdCity,
                                    type: showCityModal ? '1' : '2',
                                });
                                dispatch(setShowCityModal(false));
                            }}
                        >
                            ذخیره
                        </Button>
                    </div>
                </DialogContent>
            </DialogPortal>
        </Dialog>
    );
};

export default CityModal;
